const ALPHANUMERIC = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';

// Bytes from MAX_BYTE up would bias the result towards the start of the alphabet,
// so they are dropped and drawn again rather than folded in with a plain modulo.
const MAX_BYTE = 256 - (256 % ALPHANUMERIC.length);

export default function generateRandomString(stringLength = 32) {
	let result = '';

	while (result.length < stringLength) {
		const bytes = new Uint8Array(stringLength - result.length);
		crypto.getRandomValues(bytes);

		for (const byte of bytes) {
			if (byte < MAX_BYTE) {
				result += ALPHANUMERIC[byte % ALPHANUMERIC.length];
			}
		}
	}

	return result;
}
